// Retry the same authenticated message, never create a second launch request.
export async function waitForRemoteHandoff(send, initial, { current = () => true, now = Date.now,
  wait = ms => new Promise(resolve => setTimeout(resolve, ms)) } = {}) {
  if (initial?.routing?.action !== 'remote_project_pending') return initial;
  const requestId = initial.routing.requestId;
  if (!/^[a-zA-Z0-9_-]{1,120}$/.test(requestId || '')) throw new Error('Could not verify the new Work chat. Open the source chat again.');
  const assert = () => { if (!current()) throw new Error('Your connection changed. Reopen this chat to recover the new task.'); };
  const deadline = now() + 45000;
  let out = initial;
  while (out?.routing?.action === 'remote_project_pending' && now() < deadline) {
    assert(); await wait(1000); assert();
    out = await send({ requestId }); assert();
    if (out?.routing?.requestId !== requestId) throw new Error('The new Work chat changed. Open the source chat again.');
  }
  if (out?.routing?.action !== 'created') throw new Error('Your Mac has not confirmed the new chat yet. Keep the updated Mac app open, then retry this message.');
  return out;
}
